import { render, staticRenderFns } from "./DoctorAsissHistory.vue?vue&type=template&id=49281f58&scoped=true"
import script from "./DoctorAsissHistory.vue?vue&type=script&lang=js"
export * from "./DoctorAsissHistory.vue?vue&type=script&lang=js"
import style0 from "./DoctorAsissHistory.vue?vue&type=style&index=0&id=49281f58&prod&scoped=true&lang=css"
import style1 from "./DoctorAsissHistory.vue?vue&type=style&index=1&id=49281f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49281f58",
  null
  
)

export default component.exports